export const formatTime = (time) => {
    return (
      Math.floor((time / 60000) % 60) +
      ":" +
      ("0" + Math.floor((time / 1000) % 60)).slice(-2)
    );
}